import type { ClientPost } from '@DigitaleDoerfer/digitale-doerfer-api';
import { useQuery } from '@tanstack/react-query';
import { useCallback } from 'react';

import { API_CACHE_KEYS } from '@/features/api/constants/cache';
import { useGrapevinePostApi } from '@/features/api/hooks/grapevine-post/useGrapevinePostApi';
import { useAuth } from '@/features/authorization/provider/useAuth';
import { getPostProps } from '@/features/posts/utils/post';
import { isEmptyOrNull } from '@/shared/utils/string';

export const useGetPostById = (postId = '') => {
  const { isAuthenticated } = useAuth();
  const api = useGrapevinePostApi();

  return useQuery({
    queryKey: [API_CACHE_KEYS.POST, { postId }],
    queryFn: () => api.getPostById({ postId }),
    select: useCallback((data: ClientPost) => getPostProps(data), []),
    enabled: isAuthenticated && !isEmptyOrNull(postId)
  });
};
